import { RevisionModel } from '../../../api/api.types';
import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router';
import { reservationApi } from '../../../api/reservation/reservation.client';
import { useTranslation } from 'react-i18next';
import AuditLog from '../../../components/tables/AuditLog';
import { LoaderBar } from '../../../components/forms/LoaderBar';

interface ReservationAuditLogLocationProps {
  number: string;
}

const ReservationAuditLog: React.FC<RouteComponentProps<ReservationAuditLogLocationProps>> =
  (props) => {

    const [ revisions, setRevisions ] = useState<RevisionModel[]>([]);
    const [ isLoading, setIsLoading ] = useState<boolean>(true);
    const { t } = useTranslation();

    useEffect(() => {
      const number = props.match.params.number;
      reservationApi.Reservations.getReservationRevisions(number)
        .then(
          (resp) => {
            setRevisions(resp.data);
          })
        .catch((err) => console.log(err))
        .finally(() => setIsLoading(false));
    }, [ props.match.params, t ]);

    return (
      <div className="page-content">
        <div className="row justify-content-end pb-2">
          <div className="col-12">
            <h1 className="mb-0">{t('page_title.reservation_logs_table_view.reservation_no', {
              reservationNumber: props.match.params.number
            })}</h1>
            <h1 className="mb-0">Reservation audit log</h1>
          </div>
        </div>
        {isLoading && <LoaderBar/>}
        {revisions && revisions.length > 0 ? (
          <AuditLog
            revisions={revisions}
            jsonFieldNames={[ 'optionalItemLog', 'chargeLog' ]}
          />
        ) : ''}
      </div>
    );
  };
export default ReservationAuditLog;